<template>
  <div class="sidebar" :class="{ close: close }">
    <div class="logo-details">
      <!-- <span class="logo_name">CodingLab</span> -->
      <img src="../../assets/images/svg/logo.svg" class="logo" />
      <img src="../../assets/images/svg/logo-name.svg" class="logo_name" />
    </div>

    <ul class="nav-links scroll">
<!--      <li>-->
<!--        <router-link to="/">-->
<!--          <i class="bx bx-grid-alt"></i>-->
<!--          <span class="link_name">Dashboard</span>-->
<!--        </router-link>-->
<!--      </li>-->

      <li id="inventory">
        <div class="iocn-link" @click="toggleSubmenu('inventory')">
          <a href="#">
            <i class="bx bx-collection"></i>
            <span class="link_name">Inventario</span>
          </a>
          <i class="bx bxs-chevron-down arrow"></i>
        </div>
        <ul class="sub-menu">
          <li class="sub-icon">
            <router-link :to="{ name: 'stock', params: { stock: 'deposito' } }">
              <i class="bx bx-cog bx-xs"></i> Deposito
            </router-link>
          </li>
          <li class="sub-icon">
            <router-link :to="{ name: 'stock', params: { stock: 'salon' } }">
              <i class='bx bx-border-all bx-xs'></i> Salon
            </router-link>
          </li>
          <!-- <li><router-link to="/inventory/leave">Inventario</router-link></li> -->
          <li class="sub-icon">
            <router-link to="/inventory/leave">
              <i class='bx bx-up-arrow-alt bx-xs'></i> Salida
            </router-link>
          </li>
        </ul>
      </li>

      <!-- <li id="post">
        <div class="iocn-link" @click="toggleSubmenu('post')">
          <a href="#">
            <i class="bx bx-book-alt"></i>
            <span class="link_name">Posts</span>
          </a>
          <i class="bx bxs-chevron-down arrow"></i>
        </div>
        <ul class="sub-menu">
          <li><a class="link_name" href="#">Posts</a></li>
          <li><a href="#">Web Design</a></li>
          <li><a href="#">Login Form</a></li>
          <li><a href="#">Card Design</a></li>
        </ul>
      </li> -->
    </ul>

    <!-- <div class="profile-details">
      <div class="profile-content">
        <img src="image/profile.jpg" alt="profileImg">
      </div>
      <div class="name-job">
        <div class="profile_name">Prem Shahi</div>
        <div class="job">Web Desginer</div>
      </div>
      <i class="bx bx-log-out"></i>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  props: {
    close: Boolean,
  },
  methods: {
    toggleSubmenu(id) {
      const submenu = document.getElementById(id);
      submenu.classList.toggle("showMenu");
    },
  },
};
</script>

<style lang="scss">
// https://www.codinglabweb.com/2021/06/dropdown-sidebar-menu-html-css.html

$primary: #11101d;

.sidebar {
  //position: fixed;
  top: 0;
  left: 0;
  width: 355px;
  background: $primary;
  z-index: 100;
  transition: all 0.5s ease;

  .logo-details {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;

    .logo {
      height: 45px;
      min-width: 78px;
      text-align: center;
      line-height: 50px;
    }

    .logo_name {
      filter: invert(1);
      height: 2rem;
      transition: 0.3s ease;
      transition-delay: 0.1s;
    }
  }

  .nav-links {
    // height: 100%;
    padding: 30px 0 30px 0;
    overflow: auto;
    scrollbar-width: none;
    background: $primary;
    &::-webkit-scrollbar {
      display: none;
    }
    li {
      position: relative;
      list-style: none;
      transition: all 0.4s ease;
      &:hover {
        background: #1d1b31;
        .sub-menu.blank {
          top: 50%;
          transform: translateY(-50%);
        }	
      }

      .iocn-link {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      i {
        height: 50px;
        min-width: 78px;
        text-align: center;
        line-height: 50px;
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        transition: all 0.3s ease;
      }
      a {
        display: flex;
        align-items: center;
        text-decoration: none;
        .link_name {
          font-size: 18px;
          font-weight: 400;
          color: #fff;
          transition: all 0.4s ease;
        }
      }
      .sub-menu {
        padding: 6px 6px 14px 40px;
        // margin-top: -10px;
        background: #1d1b31;
        display: none;
        a {
          color: #fff;
          font-size: 15px;
          padding: 5px 0;
          white-space: nowrap;
          opacity: 0.6;
          transition: all 0.3s ease;
          &:hover {
            opacity: 1;
          }
        }
        .link_name {
          display: none;
        }
        .sub-icon{
          i{line-height: 30px; min-width: 30px; height: auto}
        }
      }
      .sub-menu.blank {
        opacity: 1;
        pointer-events: auto;
        padding: 3px 20px 6px 16px;
        opacity: 0;
        pointer-events: none;
      }
    }
    li.showMenu {
      i.arrow {
        transform: rotate(-180deg);
      }
      .sub-menu {
        display: block;
      }
    }
  }

  .profile-details {
    position: fixed;
    bottom: 0;
    width: 260px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #1d1b31;
    padding: 12px 0;
    transition: all 0.5s ease;
    .profile-content {
      display: flex;
      align-items: center;
    }
    img {
      height: 52px;
      width: 52px;
      object-fit: cover;
      border-radius: 16px;
      margin: 0 14px 0 12px;
      background: #1d1b31;
      transition: all 0.5s ease;
    }
    .profile_name {
      color: #fff;
      font-size: 18px;
      font-weight: 500;
      white-space: nowrap;
    }
    .job {
      color: #fff;
      font-size: 18px;
      font-weight: 500;
      white-space: nowrap;
      font-size: 12px;
    }
  }
}

.sidebar.close {
  width: 78px;
  .logo-details {
    .logo_name {
      transition-delay: 0s;
      opacity: 0;
      pointer-events: none;
    }
  }
  .nav-links {
    overflow: visible;
    li {
      .iocn-link {
        display: block;
      }
      a {
        .link_name {
          opacity: 0;
          pointer-events: none;
        }
      }
      .sub-menu {
        position: absolute;
        left: 100%;
        top: -10px;
        margin-top: 0;
        padding: 10px 20px;
        border-radius: 0 6px 6px 0;
        opacity: 0;
        display: block;
        pointer-events: none;
        transition: 0s;
        .link_name {
          font-size: 18px;
          opacity: 1;
          display: block;
        }

      }
      &:hover {
        .sub-menu {
          opacity: 1;
          pointer-events: auto;
          transition: all 0.4s ease;
        }
      }
    }
    i.arrow {
      display: none;
    }
  }
  .profile-details {
    background: none;
    width: 78px;
    img {
      padding: 10px;
    }
    i {
      display: none;
    }
    .profile_name {
      display: none;
    }
    .job {
      display: none;
    }
  }
  ~ {
    .home-section {
      left: 78px;
      width: calc(100% - 78px);
    }
  }
}
.home-section {
  position: relative;
  background: #e4e9f7;
  height: 100vh;
  left: 260px;
  width: calc(100% - 260px);
  transition: all 0.5s ease;
  .home-content {
    height: 60px;
    display: flex;
    align-items: center;
    .bx-menu {
      color: #11101d;
      font-size: 35px;
      margin: 0 15px;
      cursor: pointer;
    }
    .text {
      color: #11101d;
      font-size: 35px;
      font-size: 26px;
      font-weight: 600;
    }
  }
}

.router-link-active{color: #2C55FB !important}
.router-link-exact-active{
  i{color: #2C55FB !important}
  .link_name{color: #2C55FB !important}
}


@media (max-width: 630px) {
  .sidebar.close{
    width: 0px;
    .logo-details { display: none; }
    .nav-links { display: none; }
  }
}
</style>
